<div class="container-fluid">
  <app-pagetitle title="CABINETYPE" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
</div>
<div class="main-card-container">
  <div class="card">
    <div class="card-body">
      <button class="btn btn-secondary" routerLink="/cabinets">Back to Cabinets</button>
      <div class="dropdown float-end" ngbDropdown>
        <a href="javascript: void(0);" class="dropdown-toggle arrow-none card-drop" ngbDropdownToggle
          data-toggle="dropdown" aria-expanded="false">
          <i class="mdi mdi-dots-vertical"></i>
        </a>
        <i class="mdi mdi-refresh" (click)="refresh()" ngbTooltip="Refresh"></i> 
      </div>
      <div class="row">
        <h4 class="card-title mb-4">Cabinet Type</h4>
      </div>
      <div class="row">
        <button type="button" class="btn btn-primary" style="height:50px;width:200px;" (click)="onAddNew(addEditModal)">Add New Cabinet Type</button>
        <div class="col-sm-12 col-md-12">
          <div id="tickets-table_filter" class="dataTables_filter text-md-end"><label
              class="d-inline-flex align-items-center">Search:
              <input type="text" name="searchTerm" class="form-control form-control-sm ms-2"
                aria-controls="tickets-table" [(ngModel)]="term" /></label></div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-centered">
          <thead class="table-light">
            <tr>
              <th>Cabinet Type</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of cabinetType|filter:term">
              <td>{{item.name}}</td>
              <td>
                <a (click)="onEdit(addEditModal, item)" class="me-3 text-primary" ngbTooltip="Edit" ><i
                    class="mdi mdi-pencil font-size-50"></i></a>
                <a (click)="onDelete(item.id)"  class="text-danger" ngbTooltip="Delete"><i
                    class="mdi mdi-trash-can font-size-18"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <ng-template #addEditModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="add-edit-modal-title" aria-modal="true">{{addEditMode}}</h4>
      <button class="btn btn-warn close" (click)="modal.dismiss('Cross click')">Close</button>
    </div>
    <div class="modal-body">
      <form class="form" [formGroup]="cabinetTypeFormGroup">
        <div class="form-group">
          <label for="name-input" style="font-size: 20px;" style="font-family: Arial;">cabinet Type</label>
          <input type="text" class="form-control" id="name-input" 
            formControlName="name"
            aria-describedby="name" placeholder="Enter cabinet Type" minlength="4"
          >
          <div class="danger" 
            *ngIf="cabinetTypeFormGroup.get('name')?.errors?.['minlength'] || cabinetTypeFormGroup.get('name').dirty"
          >Must be at least 4 characters</div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button 
        class="btn btn-primary btn-outline-dark" style="height:50px;width:200px;"
        (click)="modal.close('Save click')"
        [disabled]="cabinetTypeFormGroup.invalid || !cabinetTypeFormGroup.get('name').value"
      >Save</button>
    </div>
  </ng-template>
</div>